import { NoteRoute } from '@/modules/note/v1/api/NoteRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { UploadParams } from '@/modules/note/v1/api/v1/files/Dto/UploadParams'

/** DELETE /api/note/v1/uploads/{upload}: отменить сессию, принятые куски стираются на узле */
export class CancelUploadRoute extends NoteRoute<null, null> {
  constructor(private readonly params: UploadParams) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.DELETE
  }

  url(): string {
    return '/api/note/v1/uploads/' + this.params.upload
  }

  offline(): Promise<ApiResponse<null>> {
    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
